<template>
  <div>
    <first-row-none-set
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      v-if="modelTransportType == null"
    />
    <first-row-transport-set
      :model-settlement-type-id-validation="modelSettlementTypeIdValidation"
      :model-settlement-type-id.sync="contextSettlementTypeId"
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      :model-vehicle-id-validation="modelVehicleIdValidation"
      :model-vehicle-id.sync="contextVehicleId"
      v-if="modelTransportType != null && (modelSettlementTypeId == null || modelSettlementTypeId === -1)"
    />
    <first-row-transport-settlement-booking-set
      :model-booking-id-validation="modelBookingIdValidation"
      :model-booking-id.sync="contextBookingId"
      :model-booking-ticket.sync="contextBookingTicket"
      :model-settlement-type-id-validation="modelSettlementTypeIdValidation"
      :model-settlement-type-id.sync="contextSettlementTypeId"
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      :model-file-id.sync="contextFileId"
      v-if="modelSettlementTypeId === 1"
      v-on:importRailRoute="importRailRoute"
      v-on:importRouteBack="importRouteBack"
      v-on:importRouteTo="importRouteTo"
    />
    <first-row-transport-settlement-lost-ticket-set
      :model-amount-validation="modelAmountValidation"
      :model-amount.sync="contextAmount"
      :model-currency-validation="modelCurrencyValidation"
      :model-currency.sync="contextCurrency"
      :model-settlement-type-id-validation="modelSettlementTypeIdValidation"
      :model-settlement-type-id.sync="contextSettlementTypeId"
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      v-if="modelSettlementTypeId === 4"
    />
    <first-row-transport-settlement-lump-sum-set
      :model-settlement-type-id-validation="modelSettlementTypeIdValidation"
      :model-settlement-type-id.sync="contextSettlementTypeId"
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      v-if="modelSettlementTypeId === 2"
    />
    <first-row-transport-settlement-provides-employer-set
      :model-amount-validation="modelAmountValidation"
      :model-amount.sync="contextAmount"
      :model-currency-validation="modelCurrencyValidation"
      :model-currency.sync="contextCurrency"
      :model-file-id-validation="modelFileIdValidation"
      :model-file-id.sync="contextFileId"
      :model-settlement-type-id-validation="modelSettlementTypeIdValidation"
      :model-settlement-type-id.sync="contextSettlementTypeId"
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      v-if="modelSettlementTypeId === 5"
    />
    <first-row-transport-settlement-scan-ticket-set
      :model-amount-validation="modelAmountValidation"
      :model-amount.sync="contextAmount"
      :model-currency-validation="modelCurrencyValidation"
      :model-currency.sync="contextCurrency"
      :model-file-id-validation="modelFileIdValidation"
      :model-file-id.sync="contextFileId"
      :model-settlement-type-id-validation="modelSettlementTypeIdValidation"
      :model-settlement-type-id.sync="contextSettlementTypeId"
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      v-if="modelSettlementTypeId === 3 || modelSettlementTypeId === 6"
    />
    <first-row-transport-settlement-already-settled
      :model-comment.sync="contextComment"
      :model-settlement-type-id.sync="contextSettlementTypeId"
      :model-comment-validation="modelCommentValidation"
      :model-settlement-type-id-validation="modelSettlementTypeIdValidation"
      :model-transport-type-validation="modelTransportTypeValidation"
      :model-transport-type.sync="contextTransportType"
      v-if="modelSettlementTypeId === 7"
    />
  </div>
</template>

<script>
import FirstRowNoneSet from "./FirstRowNoneSet.vue";
import FirstRowTransportSet from "./FirstRowTransportSet.vue";
import FirstRowTransportSettlementBookingSet from "./FirstRowTransportSettlementBookingSet.vue";
import FirstRowTransportSettlementLostTicketSet from "./FirstRowTransportSettlementLostTicketSet.vue";
import FirstRowTransportSettlementLumpSumSet from "./FirstRowTransportSettlementLumpSumSet.vue";
import FirstRowTransportSettlementProvidesEmployerSet from "./FirstRowTransportSettlementProvidesEmployerSet.vue";
import FirstRowTransportSettlementScanTicketSet from "./FirstRowTransportSettlementScanTicketSet.vue";
import FirstRowTransportSettlementAlreadySettled from "./FirstRowTransportSettlementAlreadySettled";

export default {
  name: "FirstRow",
  props: {
    modelTransportType: {
      required: true
    },
    modelSettlementTypeId: {
      required: true
    },
    modelVehicleId: {
      required: true
    },
    modelCurrency: {
      required: true
    },
    modelAmount: {
      required: true
    },
    modelBookingId: {
      required: true
    },
    modelBookingTicket: {
      required: true
    },
    modelFileId: {
      required: true
    },
    modelComment: {
      required: true
    },
    modelTransportTypeValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelSettlementTypeIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelVehicleIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelCurrencyValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelAmountValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelBookingIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelFileIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelCommentValidation: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  components: {
    FirstRowTransportSettlementAlreadySettled,
    FirstRowTransportSettlementScanTicketSet,
    FirstRowTransportSettlementProvidesEmployerSet,
    FirstRowTransportSettlementLumpSumSet,
    FirstRowTransportSettlementLostTicketSet,
    FirstRowTransportSettlementBookingSet,
    FirstRowNoneSet,
    FirstRowTransportSet
  },
  computed: {
    contextTransportType: {
      set: function(value) {
        this.$emit("update:modelTransportType", value);
        if (value === 1) {
          //środek transportu samochód
          this.$emit("update:modelSettlementTypeId", -1); //settlement type - kilometrówka
        } else if (value !== 1 && this.contextSettlementTypeId === -1) {
          //środek transportu samochód
          this.$emit("update:modelSettlementTypeId", null);
        } else if (value !== 7 && this.contextSettlementTypeId === 2) {
          //środek transportu różny od komunikacja miejska i typ ryczałt
          this.$emit("update:modelSettlementTypeId", null);
        }
      },
      get: function() {
        return this.modelTransportType;
      }
    },
    contextSettlementTypeId: {
      set: function(value) {
        this.$store.dispatch("Delegation/removeFile", this.contextFileId);
        this.contextFileId = null;
        this.$emit("update:modelSettlementTypeId", value);
      },
      get: function() {
        return this.modelSettlementTypeId;
      }
    },
    contextVehicleId: {
      set: function(value) {
        this.$emit("update:modelVehicleId", value);
      },
      get: function() {
        return this.modelVehicleId;
      }
    },
    contextBookingId: {
      set: function(value) {
        this.$emit("update:modelBookingId", value);
      },
      get: function() {
        return this.modelBookingId;
      }
    },
    contextBookingTicket: {
      set: function(value) {
        this.$emit("update:modelBookingTicket", value);
      },
      get: function() {
        return this.modelBookingTicket;
      }
    },
    contextAmount: {
      set: function(value) {
        this.$emit("update:modelAmount", value);
      },
      get: function() {
        return this.modelAmount;
      }
    },
    contextCurrency: {
      set: function(value) {
        this.$emit("update:modelCurrency", value);
      },
      get: function() {
        return this.modelCurrency;
      }
    },
    contextFileId: {
      set: function(value) {
        this.$emit("update:modelFileId", value);
      },
      get: function() {
        return this.modelFileId;
      }
    },
    contextComment: {
      set: function(value) {
        this.$emit("update:modelComment", value);
      },
      get: function() {
        return this.modelComment;
      }
    }
  },
  methods: {
    importRouteTo(item) {
      this.$emit("importRouteTo", item);
    },
    importRouteBack(item) {
      this.$emit("importRouteBack", item);
    },
    importRailRoute(item) {
      this.$emit("importRailRoute", item);
    }
  }
};
</script>

<style scoped></style>
